import React,{Component} from 'react'
import Link from 'react-router'
import {addLocaleData, IntlProvider, FormattedMessage} from 'react-intl';
import {language} from 'UTIL/common'

export default class ContentHeader extends Component{
     render(){
        return (
            <div>
                <section className="content-header">
                    <h1>{language()[this.props.nameLg]}<small>{language()[this.props.nameSm]}</small>
                    </h1>
				</section>
            </div>
        )
     }
}


// WEBPACK FOOTER //
// ./modules/component/contentHeaderLeft.js